import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../organisms/Layout/Layout';
import BubbleCtaSection from '../../organisms/BubbleCtaSection/BubbleCtaSection';
import { renderPageSections } from '../renderPageSections';

const suiteTypeToSections = (sectionArray, suite) => {
  return sectionArray.map(section => {
    if (section._type === 'multiSection') {
      const newMultiSection = section.sections.map(sect => {
        return { ...sect, suiteType: suite };
      });
      return { ...section, sections: newMultiSection };
    }
    return { ...section, suiteType: suite };
  });
};

const SuiteBenefitsPage = ({ data, location: { href } }) => {
  // unpublished pages return null data
  if (!data || data.sanitySuitebenefitspage === null) {
    return null;
  }

  const suiteBenefitsPageProps = {
    id: data.sanitySuitebenefitspage._id,
    metadata: { ...data.sanitySuitebenefitspage._rawRoute, href },
    sections: suiteTypeToSections(
      data.sanitySuitebenefitspage._rawSections,
      data.sanitySuitebenefitspage.suiteType
    ),
    suiteType: data.sanitySuitebenefitspage.suiteType,
    bubbleCtaSection: data.sanitySuitebenefitspage._rawBubbleCtaSection,
  };

  return (
    <Layout
      menuColor="gray"
      {...suiteBenefitsPageProps.metadata}
      sanityId={suiteBenefitsPageProps.id}
    >
      {renderPageSections(suiteBenefitsPageProps.sections)}
      {suiteBenefitsPageProps.bubbleCtaSection && (
        <BubbleCtaSection {...suiteBenefitsPageProps.bubbleCtaSection} />
      )}
    </Layout>
  );
};

SuiteBenefitsPage.propTypes = {
  data: PropTypes.shape({
    sanitySuitebenefitspage: {},
  }),
  location: PropTypes.shape({ href: PropTypes.string }),
};

SuiteBenefitsPage.defaultProps = {
  data: {},
  location: { href: '' },
};

export default SuiteBenefitsPage;

export const query = graphql`
  query($slug: String) {
    sanitySuitebenefitspage(
      route: { enabled: { eq: true }, slug: { current: { eq: $slug } } }
    ) {
      _id
      _rawRoute(resolveReferences: { maxDepth: 100 })
      _rawSections(resolveReferences: { maxDepth: 100 })
      _rawBubbleCtaSection(resolveReferences: { maxDepth: 100 })
      suiteType
    }
  }
`;
